
  export default {
    apiUrl:  'https://meta-live.haimacloud.com',
    productName: '镜渊星游',
    fileUrl: 'http://live-pkg.haimacloud.com',
    loggerUrl: 'https://countly-pre.haimawan.com/i',
    'bid': 'shanhai',
    agreements: [
        'https://hkx-file-3058.oss-cn-beijing.aliyuncs.com/daas/%E9%95%9C%E6%B8%8A%E6%98%9F%E6%B8%B8%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf',
        'https://hkx-file-3058.oss-cn-beijing.aliyuncs.com/daas/%E9%95%9C%E6%B8%8A%E6%98%9F%E6%B8%B8%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf',
      ],
    help: 'https://hkx-file-3058.oss-cn-beijing.aliyuncs.com/daas/%E9%95%9C%E6%B8%8A%E6%98%9F%E6%B8%B8%E6%95%B0%E5%AD%97%E4%BA%BA%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.pdf',
    opentools: 'false',
    channelId: '01',
    closePay: 'true',
    videoPayDes: '· 视频输出时长,· 免费数字人,· 免费音色'
}
